module.exports = __webpack_public_path__ + "static/img/goBei-img.c5abe18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/goBei-img.png
// module id = uWlY
// module chunks = 1